<div class="main-content">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="content px-5 table-responsive table-full-width">
                        <table class="table table-hover table-striped">
                            <thead>
                                <tr>
                                    <th>Date</th>
                                    <th>Amount</th>
                                    <th>Credits</th>
                                    <th>Status</th>
                                    <th>Action</th>


                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let his of history">
                                    <td>{{this.util.formatDate(his.dateUTC)}}</td>
                                    <td>{{his.amount |number}}</td>
                                    <td>{{his.credits}}</td>
                                    <td>{{his.status}}</td>
                                    <td> <button class="btn btn-success" (click)="checkpayment(his)" [style]="style.btnstyle"
                                            [disabled]="disableButton || his.status=='Completed' || his.status=='Failed'">Recheck</button></td>

                                </tr>
                            </tbody>
                        </table>
                        <p *ngIf="history.length==0"> No Payment History</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>